import React from 'react'
import { Link } from 'react-router-dom'
import ActivityLogsIcon from 'material-ui/svg-icons/action/history'
import Settings from 'material-ui/svg-icons/action/settings'
import Notification from 'material-ui/svg-icons/social/notifications'
import Payment from 'material-ui/svg-icons/action/payment'
import PinDrop from 'material-ui/svg-icons/maps/pin-drop'
import Book from 'material-ui/svg-icons/action/book'
import Language from 'material-ui/svg-icons/action/language'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import { FormattedMessage } from 'react-intl'
import { menuItemStyles, trialPeriodDialogStyle, trialPeriodDialogTitleStyle, trialDialogDescriptionStyle } from './styles'
import { Helmet } from 'react-helmet'
import User from 'material-ui/svg-icons/social/people'
import { connect } from 'react-redux'
import { fetchPlanDetails } from '../../components/PlanDetails/actions'
import { getToken, checkView, checkJapanese } from '../../lib'
import images from '../../config/images'
import Dialog from 'material-ui/Dialog'
import config from '../../config/config'
import FlatButton from 'material-ui/FlatButton';
import Sidebar from "react-sidebar";
import RoomRecordingsIcon from '../../images/soraRecording.svg';
import WebinarIcon from '../../images/webinar.png';
import ConferenceIcon from '../../images/conference.png';
import CommunicationEmail from 'material-ui/svg-icons/communication/email'

(function () {
  var link = document.querySelector('link[rel*=\'icon\']') || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = window.location.origin + '/img/faviconFVlite.ico'
  document.getElementsByTagName('head')[0].appendChild(link)
})()

function Questionnaire({ isCampaign }) {

  function answerSurvey() {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSd-zQYMqdt3K-Jj6lGz5avZ8VBtTXQbhPFk3KGMSgUO4cDEbw/viewform', '_blank');
  }

  return (
    <div style={{ marginTop: "30px" }}>
      <p className="text-center">
        <FormattedMessage id="CreateDomainLabel.questionnaireHeading" />
      </p>
      <p style={{ fontSize: "14px" }} className="text-center">
        <FormattedMessage id="CreateDomainLabel.questionnaireHeading1" />
      </p>
      <div style={{ marginLeft: isCampaign ? '4px' : '0px'}}>
      <FlatButton
        backgroundColor="#43c6c4"
        hoverColor="#3dbbb9"
        style={{ display: "block", minWidth: isCampaign ? "288px" : "160px",maxWidth: isCampaign ? "288px" : "160px", margin: "auto", }}
        label={<FormattedMessage id="CreateDomainLabel.answerSurvey" />}
        labelStyle={{ color: "#fff", padding: 0 }}
        onTouchTap={(e) => answerSurvey()}
      />
      </div>
    </div>
  );
}

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      campaignDiaglog: false,
    };
  }
  componentDidMount() {
    checkView()
    this.props.view === 'desktop' ? this.props.toggleSideBar(true) : this.props.toggleSideBar(false);
    const token = getToken()
    this.props.fetchPlanDetails(token);
    if (this.props.fvliteExpireFlag === true) {
      this.setState({ campaignDiaglog: true });
    }
  }

  openPlanPopup = () => {
    this.handleClose();
    this.props.history.push('/admin/settings/manage-plans/campaign')
  }

  handleClose = () => {
    this.setState({ campaignDiaglog: false })
  }

  toggleMenu = () => {
    if (this.props.view !== 'desktop') {
      this.props.toggleSideBar(!this.props.openSidebar)
    }
  }

  handleLanguage = () => {
    let locale = localStorage.getItem('locale')
    if (locale == 'ja') {
      localStorage.setItem('locale', 'en')
    } else {
      localStorage.setItem('locale', 'ja')
    }
    window.location.reload()
  }

  /**
   * Conditions to show plans
   * 1.If the domain type is Path domain
   *    1. If the user is domain owner
   *    2. If the user is admin user
   *    3. Trial users
   * 2.If the domain type is Sub Domain
   *    1. Trial user
   */
  showPlan = () => {
    // Path Domain
    if(this.props.fvDomainType === "Path Domain") {
      return (this.props.currentUser === this.props.fvDomainOwner) 
      || (this.props.user.fvlite_role === "admin") 
      || (this.props.user.sessions_plan === null && this.props.user.fvlite_role !== "admin" && this.props.user.plan !== "free")
    } else {
      // Sub Domain
      return (
        this.props.user.sessions_plan === null 
        && !this.props.user.admin && this.props.role !== 'admin' 
        && this.props.user.plan !== "free"
        && (this.props.currentUser !== this.props.fvDomainOwner)
        )
    };
  }

  getSideMenuItem = (props, subDomain) => {
    return (<Menu
      disableAutoFocus
      selectedMenuItemStyle={{
        backgroundColor: 'rgba(231, 235, 240)',
        color: '#6B7C93'
      }}
      value={props.path}
      autoWidth={false}
      width='100%'
      style={{ width: '100%' }}>
      {props.enableConference === true && <MenuItem
        value={'/admin'}
        primaryText={<FormattedMessage id='loggedInNavigation.fvlite_room' />}
        containerElement={<Link to={'/admin'} />}
        leftIcon={<img src={ConferenceIcon} />}
        style={menuItemStyles}
        onClick={() => this.toggleMenu()} />}
      {props.enableWebinar === true && <MenuItem
        value={'/admin/webinar'}
        primaryText={<FormattedMessage id='loggedInNavigation.webinar_rooms' />}
        containerElement={<Link to={'/admin/webinar'} />}
        leftIcon={<img src={WebinarIcon} />}
        style={menuItemStyles}
        onClick={() => this.toggleMenu()} />}
      <MenuItem
        value={'/admin/questionnaires'}
        primaryText={<FormattedMessage id='roomList.questionnaire' />}
        containerElement={<Link to={'/admin/questionnaires'} />}
        leftIcon={<img src={images.editBookIcon} />}
        style={menuItemStyles}
        onClick={() => this.toggleMenu()} />
      <MenuItem
        value={'/admin/email-address-book'}
        primaryText={<FormattedMessage id='loggedInNavigation.emailAddressBook' />}
        containerElement={<Link to={'/admin/email-address-book'} />}
        leftIcon={<CommunicationEmail color='#6B7C93' />}
        style={menuItemStyles}
        onClick={() => this.toggleMenu()} />
      <MenuItem
        value={'/admin/calls/logs'}
        primaryText={<FormattedMessage id='loggedInNavigation.activityLogs' />}
        containerElement={<Link to={'/admin/calls/logs'} />}
        leftIcon={<ActivityLogsIcon color='#6B7C93' />}
        style={menuItemStyles}
        onClick={() => this.toggleMenu()} />
          {/* <MenuItem
        value={'/admin/room_recordings'}
        primaryText={<FormattedMessage id='loggedInNavigation.roomRecordings' />}
        containerElement={<Link to={'/admin/room_recordings'} />}
        leftIcon={<img src={RoomRecordingsIcon} />}
        style={menuItemStyles}
        onClick={() => this.toggleMenu()} /> */}
      <MenuItem
        value={'/admin/news'}
        primaryText={<FormattedMessage id='loggedInNavigation.notice' />}
        containerElement={<Link to={'/admin/news'} />}
        leftIcon={<Notification color='#6B7C93' />}
        style={menuItemStyles}
        onClick={() => this.toggleMenu()} />
      <MenuItem
        value={'/admin/settings'}
        primaryText={<FormattedMessage id='loggedInNavigation.settings' />}
        containerElement={<Link to={'/admin/settings'} />}
        leftIcon={<Settings color={'#6B7C93'} />}
        style={menuItemStyles}
        onClick={() => this.toggleMenu()} />
      {props.role === 'admin' &&
        <MenuItem
          value={'/admin/users'}
          primaryText={<FormattedMessage id='user.userList' />}
          containerElement={<Link to={'/admin/users'} />}
          leftIcon={<User color={'#6B7C93'} />}
          style={menuItemStyles}
          onClick={() => this.toggleMenu()}
        />
      }
      {/* {props.fvDomainType === "Sub Domain" ?
        <MenuItem
          value={`https://${props.planDetails}.lfv.jp/recordings/`}
          primaryText={<FormattedMessage id='loggedInNavigation.recordings' />}
          containerElement={<Link to={`https://${props.planDetails}.lfv.jp/recordings/`} target="_blank" />}
          leftIcon={<Recordings color={'#6B7C93'} />}
          style={menuItemStyles}
          onClick={() => this.toggleMenu()}
        />
        :
        <MenuItem
          value={`https://${subDomain}.lfv.jp/${props.planDetails}/recordings/`}
          primaryText={<FormattedMessage id='loggedInNavigation.recordings' />}
          containerElement={<Link to={`https://${subDomain}.lfv.jp/${props.planDetails}/recordings/`} target="_blank" />}
          leftIcon={<Recordings color={'#6B7C93'} />}
          style={menuItemStyles}
          onClick={() => this.toggleMenu()}
        />
      } */}
        {this.showPlan() ?
        <MenuItem
          value={'/admin/settings/manage-plans/:campaign?'}
          primaryText={<FormattedMessage id='loggedInNavigation.managePlans' />}
          containerElement={<Link to={'/admin/settings/manage-plans'} />}
          leftIcon={<Payment color='#6B7C93' />}
          style={menuItemStyles}
          onClick={() => this.toggleMenu()}
        /> : ''}
        {(props.enableIPFilter === true && props.role === 'admin') ?
        <MenuItem
          value={'/admin/settings/ip-addresses'}
          primaryText={<FormattedMessage id='loggedInNavigation.IPAddresses' />}
          containerElement={<Link to={'/admin/settings/ip-addresses'} />}
          leftIcon={<PinDrop color='#6B7C93' />}
          style={menuItemStyles}
          onClick={() => this.toggleMenu()}
        /> : ''}
        {this.props.view === 'mobile' || this.props.view === 'sm-mobile' ?
        <MenuItem
          primaryText={<FormattedMessage id="loggedInNavigation.manual" />}
          href='https://drive.google.com/drive/folders/1IDbugtjQDn3Oet9ffa-0j8rSovFgx5Uk'
          leftIcon={<Book color='#6B7C93' />}
          style={menuItemStyles}
          onClick={() => this.toggleMenu()}
        /> : ''}
       {this.props.view === 'sm-mobile' ?
        <MenuItem
          primaryText={'日本語/English'}
          leftIcon={<Language color='#6B7C93' />}
          style={menuItemStyles}
          onClick={() => this.handleLanguage()}
        /> : ''}
      {this.props.expires_in !== 'never' && props.fvlite_auto_trial && props.fvliteExpireFlag !== null &&
        <div style={trialPeriodDialogStyle}>
          <h3 style={trialPeriodDialogTitleStyle}><FormattedMessage id="trialPlanDialog.onTrial" /></h3>
          <div style={trialDialogDescriptionStyle}>
            <p style={{ margin: "0" }}><FormattedMessage id="trialPlanDialog.period" />
              {this.props.expires_in > 0 ?
                <span>
                  {this.props.expires_in}
                  <FormattedMessage id="plan.trialEndsIn" />
                </span>
                :
                <span>
                  <FormattedMessage id="plan.expired" />
                </span>
              }</p>
          </div>
          <p style={{ color: '#9eaaba' }}><FormattedMessage id="trialPlanDialog.descriptionText" /></p>
          <FlatButton
            backgroundColor="#43c6c4"
            hoverColor="#3dbbb9"
            style={{ display: 'block', minWidth: '100%' }}
            label={<FormattedMessage id="trialPlanDialog.goToFormPage" />}
            labelStyle={{ color: '#fff' }} onTouchTap={(e) => this.openPlanPopup()} />
        </div>
      }
      {props.campaign && props.fvlite_auto_trial && props.fvliteExpireFlag !== null ?
        <div onClick={(e) => this.openPlanPopup()} style={{ cursor: 'pointer' }}>
          <img src={images.campaign1Image} />
        </div>
        : ''}
      </Menu>)
  }

  getRootSidebarClass() {
   if ((this.props.view === 'mobile' || this.props.view === 'sm-mobile' ) && this.props.openSidebar) {
     return 'mobile-open main-sidebar'
   } else if ((this.props.view === 'mobile' || this.props.view === 'sm-mobile' ) && !this.props.openSidebar) {
     return 'mobile-close main-sidebar'
   } else if (this.props.view === 'desktop') {
     return 'desktop-view main-sidebar'
   }
  }

  render() {
    const { props } = this;
    let subDomain = config.URI === 'https://workshop.tokyo' ? 'fv' : 'video-dev';
    return (
      <div><Dialog
        contentStyle={{ width: '95%', top: '-150px', maxWidth: '900px' }}
        open={this.state.campaignDiaglog}
        onRequestClose={this.handleClose}>
        <div>
          {this.props.campaign && <div><center style={{ cursor: 'pointer' }} onClick={() => this.openPlanPopup()}><img src={images.campaign2Image} /></center>{checkJapanese() && <Questionnaire isCampaign={true} />}</div>}
        </div>

        {!this.props.campaign &&<div> <div>
          <h2 className="text-center"><FormattedMessage id="plan.expired" /></h2>
          <p className="text-center"><FormattedMessage id="CreateDomainLabel.thanksForUsingTrial" /></p>
          <p className="text-center"><FormattedMessage id="CreateDomainLabel.continueService" /></p>
          <FlatButton
            backgroundColor="#43c6c4"
            hoverColor="#3dbbb9"
            style={{ display: 'block', minWidth: '160px', margin: 'auto' }}
            label={<FormattedMessage id="trialPlanDialog.goToFormPage" />}
            labelStyle={{ color: '#fff' }} onTouchTap={(e) => this.openPlanPopup()} />
        </div>
        {checkJapanese() && <Questionnaire isCampaign={false} />}
        </div>}
      </Dialog>
        <div className='h-100 flex flex-column justify-between'>
          <Helmet>
            <title>{'Lite FreshVoice'}</title>
          </Helmet>
              <Sidebar
                children=""
                sidebar={this.getSideMenuItem(props, subDomain)}
                open={props.openSidebar}
                styles={{ sidebar: { background: "#f6f9fc", top: '65px' } }}
                shadow={false}
                transitions={true}
                rootClassName={this.getRootSidebarClass()}
                sidebarClassName="sidebar"
                overlayClassName="sidebar-overlay"
                onSetOpen={() => {this.props.toggleSideBar(false)}}
            />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    role: state.loginLayout.user.fvlite_role,
    planDetails: state.planDetails.domainUrlName,
    fvDomainType: state.planDetails.fvDomainType,
    enableIPFilter: state.planDetails.enableIPFilter,
    enableWebinar: state.planDetails.enableWebinar,
    enableConference: state.planDetails.enableConference,
    fvDomainOwner: state.planDetails.fvDomainOwner,
    currentUser: state.loginLayout.user.id,
    fvliteExpireFlag: state.loginLayout.user.fvlite_expire_flag,
    fvlite_auto_trial: state.planDetails.fvlite_auto_trial,
    campaign: state.planDetails.campaign,
    subscribedUser: state.loginLayout.user.stripe_sub_id,
    expires_in: state.loginLayout.user.expires_in,
  }
}
const mapDispatchToProps = dispatch => ({
  fetchPlanDetails: (token) => dispatch(fetchPlanDetails(token))
})
export default connect(mapStateToProps, mapDispatchToProps)(Navigation)



// WEBPACK FOOTER //
// src/layouts/LoggedIn/Navigation.js